import { Action, combineReducers, configureStore, ThunkAction } from '@reduxjs/toolkit';
import authReducer from '../features/authentication/authSlice';
import applicantReducer from '../features/admin/ApplicantsView/applicantsSlice';
import settingsReducer from '../features/admin/settings/settingsSlice';
import appReducer from './appSlice';
import categoryReducer from '../features/admin/questions/CategoriesView/categorySlice';
import questionReducer from '../features/admin/questions/QuestionsView/questionSlice';
import attemptsReducer from '../features/applicant/TestView/attemptSlice';
import answersReducer from '../features/applicant/TestView/answerSlice';
import scoresReducer from '../features/admin/ApplicantsView/scoreSlice';

const rootReducer = combineReducers({
  app: appReducer,
  auth: authReducer,
  applicants: applicantReducer,
  categories: categoryReducer,
  questions: questionReducer,
  settings: settingsReducer,
  attempts: attemptsReducer,
  answers: answersReducer,
  scores: scoresReducer
});
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'app/setDialog',
          'questions/fetchImage/fulfilled',
          'attempts/fetchApplicantAttempt/fulfilled',
          'attempts/createAttempt/fulfilled',
          'attempts/fetchAttempts/fulfilled',
          'attempts/retrieveAttempt/fulfilled'
        ],
        ignoredPaths: ['app.dialog.onOk', 'attempts.attempt.endTime', 'attempts.allAttempts']
      }
    })
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
